import React, { useEffect, useState } from 'react';
import '../styles/login.css';
import Apis from '../services/apis';
import { useNavigate, useParams } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const Signin = () => {
  const [email, setEmail] = useState('');
  const [code,setCode] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const apis = new Apis();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const type = useParams();
  console.log(type);
  const isgenMode= (type.type === "generate"?true:false);
  const [gencode,setgencode] = useState("");

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
    
      try {
        let token = code;
        const decoded = jwtDecode(token);
        console.log(decoded);

        let email = decoded.email;
        let password = decoded.password;

        const result = await apis.loginUser(email, password);
    
        if (result.status === "SUCCESS") {
          const {
            accessToken,
            refreshToken,
            accessTokenExpiresAt,
          } = result;

          localStorage.clear();
          localStorage.setItem("email", email);
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem(
            "accessTokenExpiresAt",
            accessTokenExpiresAt.toString()
          );
          let roleRes = await apis.userRole();
          roleRes = roleRes?.data;
          if(roleRes.is_admin)
          {
            roleRes["roles"] = [
              {
                  "role_name": "Admin"
              }
          ]
          }
          localStorage.setItem("user_id", roleRes.user_id);
          localStorage.setItem("organization_id", roleRes.organization_id);
          localStorage.setItem("roles", JSON.stringify(roleRes.roles));
          localStorage.setItem("user_name", roleRes.user_name);
          if(roleRes.roles.filter((role) => {return role.role_name === "Terminal Officer"}).length > 0)
          {navigate("/family-dashboard")}
          else if(roleRes.roles.filter((role) => {return  role.role_name === "Admin"}).length > 0)
            {navigate("/orgs")}
          else if(roleRes.roles.filter((role) => {return role.role_name === "Terminal Client"}).length > 0)
            {navigate(`/client-holdings?id=${roleRes.user_id}&&name=${roleRes.user_name}`);}
          else{
            alert("Unauthorized User. Contact Support.");
          }
        }
        else{
            alert("Error Please Contact Support.");
        }
      } catch (err) {
        alert("Error logging in: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    const handleSubmit2 = async () => {
        if (!email || !password) {
          alert("Email and password required");
          return;
        }
      
        setLoading(true);
      
        try {
          const response = await fetch(
            "https://schedulerapi.pricingculture.com/holdings/getCode",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                email,
                password,
              }),
            }
          );
      
          const data = await response.json();
      
          if (!response.ok) {
            throw new Error(data?.message || "Failed to generate code");
          }
      
          console.log("SUCCESS:", data);
          setgencode(data.token);
        //   alert("Sign-in code generated successfully");
      
          // optional redirect
          // navigate("/signin");
      
        } catch (err) {
          console.error("FETCH ERROR:", err);
          alert(err.message || "Something went wrong");
        } finally {
          setLoading(false);
        }
      };

      const handleCopy = async (text) => {
        try {
          if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            alert("Copied to clipboard");
          } else {
            // 🔙 Fallback for HTTP / older browsers
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed"; // avoid scroll jump
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            alert("Copied to clipboard");
          }
        } catch (err) {
          console.error("Copy failed", err);
        }
      };

    return (
      <div className="page-container">
        <div className="xcontainer">
          <div className="branding">
          <img
            src="https://cdn.prod.website-files.com/6704fe9ff2554866b346ff70/6949702df1e902a9654a063a_Pricing%20Culture.JPG"
            alt="Pricing Culture Logo"
            className="logo-img"
            style={{ paddingTop: '10px' }}
          />
          </div>

         {!isgenMode&&( <div>
            <h1 className="title">Sign In to Demo Account</h1>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                <input
                    type="text"
                    className="form-input"
                    placeholder="Enter access code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    // required
                />
                </div>

                <button type="submit" className="submit-btn" style={{display:'flex', justifyContent:'center', alignItems:'center',marginTop:40}}>
                {!loading
                ?
                ("Sign in")
                :
                <div
                    style={{
                    width: '20px',
                    height: '20px',
                    border: '10px solid rgba(255,255,255,0.2)',
                    borderTop: '10px solid #F4A31E',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    }}
                />}
                </button>
            </form>
          </div>)}

        {isgenMode&&(<div>
            <h1 className="title">Generate Sign In Code</h1>

            <div >
              <div className="form-group">
                <input
                  type="text"
                  className="form-input"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
  
              <div className="form-group">
                <input
                  type="text"
                  className="form-input"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
  
              <button  onClick={handleSubmit2} type="button" className="submit-btn" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                {!loading
                ?
                ("Generate Code")
                :
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    border: '10px solid rgba(255,255,255,0.2)',
                    borderTop: '10px solid #F4A31E',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                  }}
                />}
              </button>
            </div>

            {gencode && (
                <div
                    style={{
                    maxWidth: "100%",
                    marginTop: 20,
                    padding: 14,
                    border: "1px solid #444",
                    borderRadius: 8,
                    backgroundColor: "#111",
                    color: "#fff",
                    position: "relative",
                    overflowX: "auto",
                    wordBreak: "break-all",
                    whiteSpace: "pre-wrap",
                    boxShadow: "0 0 10px rgba(0,0,0,0.4)",
                    }}
                >
                    {/* Action buttons */}
                    <div
                    style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        display: "flex",
                        gap: 6,
                    }}
                    >
                    <button
                        onClick={() => handleCopy(gencode)}
                        style={{
                        fontSize: 12,
                        padding: "4px 8px",
                        cursor: "pointer",
                        borderRadius: 4,
                        border: "1px solid #666",
                        background: "#222",
                        color: "#fff",
                        }}
                    >
                        Copy
                    </button>

                    <button
                        onClick={() => setgencode("")}
                        style={{
                        fontSize: 12,
                        padding: "4px 8px",
                        cursor: "pointer",
                        borderRadius: 4,
                        border: "1px solid #a33",
                        background: "#2a0000",
                        color: "#ffb3b3",
                        }}
                    >
                        Clear
                    </button>
                    </div>

                    {/* Content */}
                    <div style={{ paddingRight: 90 }}>
                    {gencode}
                    </div>
                </div>
                )}
        </div>
        )}
        </div>
      </div>
    )
  
};

export default Signin;